import { OrderItemSerializable } from './order-item-serializable';

export class AdjustmentOrderItemSerializable extends OrderItemSerializable {
  adjustedOrderId: number;
  adjustedOrderItemId: number;
  adjustedAmount: number;
  isFullRefund: boolean;
}
